import React, {Component} from 'react';
import {Button, Form, Input, Modal, Pagination, Select, Tabs, DatePicker, message} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../components/baseTable/BaseTable";
import BaseComponent from "../../base/BaseComponent";
import $ from "jquery";
import {formatTime} from "../../utils";


const {Search} = Input;
const {TabPane} = Tabs;
const { RangePicker } = DatePicker;

class ApproximationsManagement extends BaseComponent {
    constructor(props) {
        super(props);
        this.state={
            param: {
                num: 1,
                size: 10,
                keyword:"",
                showRef: [
                    "receiverIds"
                ],
            },
            total:"",
            dataSource:[],//页面数据
            tabbarDetails:"全部",//当前切换tabbar栏为哪一栏
            addModalVisible:false,//新增弹窗开关
            delModalVisible:false,//删除弹窗开关
            datailsModalVisible:false,//详情数据弹窗开关
            checkCorrespondentVisible:false,//选择通讯员弹窗
            checkCorrespondentTotal:20,//通讯员数据长度
            replyDate:"",//回稿时间
            requireContent:"",//稿件要求
            addBody:{
                requireContent: "约稿测试",
                replyDate: "",
                status: "未领取",
                receiverIds: [
                    {
                        receiver: {
                            account: "mjh",
                            name: "马佳恒",
                            depts: [
                                {
                                    id: 4,
                                    name: "测试部"
                                }
                            ]
                        }
                    },
                    {
                        receiver: {
                            account: "lhqshr",
                            name: "李红旗",
                            depts: [
                                {
                                    id: 1,
                                    name: "融媒体事业部"
                                },
                                {
                                    id: 4,
                                    name: "测试部"
                                }
                            ]
                        }
                    }
                ],
                medias: [
                    {
                        code: "dddddz",
                        name: "测试媒体2号"
                    },
                    {
                        code: "asdas",
                        name: "测试媒体3号"
                    }
                ]
            }
        }
    }
    componentDidMount() {
        //获取当前页面数据
        this.getPageData()
    }

    render() {
        return <div style={{margin:15,background:"#fff",paddingTop:"24px",borderRadius:"5px"}}>
                    {/*页面头部新增及搜索框*/}
                    {this.renderHeader()}
                    {/*页面tab栏*/}
                    {this.renderTab()}
                    {/*页面表格*/}
                    {this.renderTable()}
                    {/*点击新增弹窗*/}
                    {this.addModal()}
                    {/*删除弹出框*/}
                    {this.delModal()}
                    {/*数据详情弹出框*/}
                    {this.detailsModal()}
                    {/*选择通讯员弹窗*/}
                    {this.checkCorrespondent()}
                </div>
    }
    //渲染页面头部新增及搜索框
    renderHeader=()=> {
        return (
            <div style={{
                display: "flex",
                padding: "0px 32px 12px 32px",
                justifyContent: "space-between",
                alignItem: "center"
            }}>
                <Button type={"primary"} onClick={() => {
                    this.setState({addModalVisible: true})
                }}>新建约稿</Button>
                <Search
                    placeholder={"请输入搜索内容"}
                    allowClear={true}
                    value={this.state.keyword}
                    onChange={(e) => {
                        this.setState({keyword: e.target.value})
                    }}
                    onSearch={(value) => {
                        this.onSearch(value)
                    }}
                    style={{width: 272, height: 32}}
                />


            </div>
        )
    }
    //渲染搜索确认的逻辑
    onSearch = (value)=>{
        let body = {
            num: 1,
            size: 10,
            keyword:value,
            keywordFiled:["requireContent","publisher.userName","receiverObjs.receiver.name"],
            showRef: [
                "receiverIds"
            ],
            params: [
                {
                    key: "status",
                    opt: "eq",
                    val: this.state.tabbarDetails
                }
            ]
        }
        this.request({
            url: "/cm-sites-business/bd/busAppointment/page",
            method:"post",
            contentType: "json",
            body: body,
            callBack: (res) => {
                this.setState({dataSource:res.data,total:res.count})
            },
            errorCallBack: (e) => {
            }
        }
        )
    }
    //渲染tab栏
    renderTab=()=>{
        let tabBarData = ["全部","未领取","进行中","已完成"];
        return (
            <div className={"approximations"}>
                <Tabs defaultActiveKey="0" onChange={(e)=>{this.changeTabbar(tabBarData[e])}}>
                    {tabBarData.map((item,index)=>{
                       return  <TabPane tab={item} key={index}></TabPane>
                    })}
                </Tabs>
                <style>{`
                    .approximations .ant-tabs-nav{margin-left: 32px}
                    .approximations .normal-tab{margin-bottom:20px}
                `}</style>
            </div>
        )
    };
    //切换tab栏的更新
    changeTabbar = (e)=>{
        let param = {};
        if(e=="全部"){
            param = {
                num: 1,
                size: 10,
                keyword:"",
                showRef: [
                    "receiverIds"
                ]
            };
            this.state.param = param
            this.setState({tabbarDetails:e});
            this.getPageData()
        }else {
            param = {
                num: 1,
                size: 10,
                keyword:"",
                showRef: [
                    "receiverIds"
                ],
                params: [
                    {
                        "key": "status",
                        "opt": "eq",
                        "val": e
                    }
                ]
            };
            this.state.param = param;
            this.setState({tabbarDetails:e});
            this.getPageData()
        }
    };
    //渲染页面表格
    renderTable = ()=>{
        const columns = [
            {
                title: '序号',
                ellipsis: true,
                align: 'left',
                render:(text,record,index)=>{
                    return <div>{`${index+1}`}</div>
                }
            },
            {
                title: '稿件要求',
                dataIndex: 'requireContent',
                key: 'requireContent',
                align: 'left',
                width:"250px",
                render:(text,record)=>{
                    return <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{text}</div>
                }
            },
            {
                title: '约稿人',
                dataIndex: 'publisher',
                key: 'publisher',
                align: 'left',
                width:"150px",
                render:(text,record)=>{
                    return <div>{record.publisher.userName}</div>
                }
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                align: 'left',
                width:"150px",
                render:(text,record)=>{
                    return <div>{formatTime(text)}</div>
                }
            },
            {
                title: '要求回稿时间',
                dataIndex: 'replyDate',
                key: 'replyDate',
                align: 'left',
                width:"150px",
                render:(text,record)=>{
                    return <div>{formatTime(text)}</div>
                }
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align: 'left',
                width:"150px",
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'left',
                width:"200px",
                render:(text,record)=>{
                    const btns = ["编辑","发布","删除","查看"]
                    return <div style={{display:"flex"}}>
                        {btns.length&&btns.map((item,index)=>{
                            return <Button key={index} type="link" size={"small"} style={{padding:0,marginRight:"3px"}} onClick={()=>{
                                if(item == "删除"){
                                    this.setState({delModalVisible:true})
                                }
                                if(item == "查看"){
                                    this.setState({datailsModalVisible:true})
                                }
                            }}>{item}</Button>
                        })}
                    </div>
                }
            },

        ]
        const dataSource = this.state.dataSource;
        return <div>
                <div style={{margin:"0 32px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={660}>
                        <BaseTable columns={columns} dataSource={dataSource}/>
                    </Scrollbars>
                </div>
                {dataSource&&dataSource.length>0 ? this.renderPage():""}
        </div>
    };
    //分页栏
    renderPage=()=>{
        let {param,total}=this.state;
        return(
            <div style={{textAlign:"right",padding:"16px 32px",borderTop:"1px solid rgb(230, 230, 230)"}}>
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共${total}条`}
                    showSizeChanger
                    showQuickJumper
                    current={param.num}
                    pageSize={param.size}
                    onChange={(e)=>{
                        param.num = e;
                        this.setState({});
                        this.getPageData()
                    }} //页码改变时回调
                    onShowSizeChange={(page,size)=>{
                        param.size = size;
                        this.setState({});
                        this.getPageData()
                    }} //每页条数改变回调
                />
            </div>
        )
    };
    //点击新增的弹窗
    addModal=()=>{
        return <Modal
            title={"新建约稿"}
            visible={this.state.addModalVisible}
            onCancel={()=>{this.setState({addModalVisible:false})}}
            onOk={()=>{
                this.addApproximations()
            }}
            width={800}
        >
            <Form.Item label={"回稿时间"} required={true} style={{display:"flex"}}>
                <DatePicker showTime placeholder="请选择时间" onChange={(e)=>{
                    this.setState({replyDate:e._d.getTime()})
                    }} onOk={(e)=>{
                    this.setState({replyDate:e._d.getTime()})
                }} />
            </Form.Item>
            <Form.Item label={"稿件要求"} required={true} style={{display:"flex"}}>
                <Input.TextArea placeholder={"请输入稿件要求"} onChange={(event)=>{
                    this.setState({requireContent:event.target.value})
                }} rows={4} style={{width:"642px", background: "rgba(0, 80, 179, 0.04)",border: "1px solid rgba(0, 80, 179, 0.08)",resize:"none" }}/>
            </Form.Item>
            <Form.Item label={"约稿对象"} required={true} style={{display:"flex"}}>
                <div style={{width:"642px", background: "rgba(0, 80, 179, 0.04)",border: "1px solid rgba(0, 80, 179, 0.08)",display:"flex",justifyContent: "space-between",cursor: "pointer"}} onClick={()=>{
                    this.setState({checkCorrespondentVisible:true})
                }
                }>
                    <div style={{marginLeft:"10px"}}>请选择约稿对象</div>
                    <div style={{marginRight:"10px"}}>&gt;</div>
                </div>
            </Form.Item>
            <Form.Item label={"发布媒体"} required={true} style={{display:"flex"}}>

            </Form.Item>
        </Modal>
    };
    //新增弹窗确认事件的回调
    addApproximations = ()=>{
        let body = {
            requireContent: this.state.requireContent,
            replyDate: this.state.replyDate,
            status: "未领取",
            receiverIds: [
                {
                    receiver: {
                        account: "mjh",
                        name: "马佳恒",
                        depts: [
                            {
                                id: 4,
                                name: "测试部"
                            }
                        ]
                    }
                },
                {
                    receiver: {
                        account: "lhqshr",
                        name: "李红旗",
                        depts: [
                            {
                                id: 1,
                                name: "融媒体事业部"
                            },
                            {
                                id: 4,
                                name: "测试部"
                            }
                        ]
                    }
                }
            ],
            medias: [
                {
                    code: "dddddz",
                    name: "测试媒体2号"
                },
                {
                    code: "asdas",
                    name: "测试媒体3号"
                }
            ]
        }
        this.request({
            url: "/cm-sites-business/bd/busAppointment/add",
            method:"post",
            contentType: "json",
            body: body,
            callBack: (res) => {
                this.setState({addModalVisible:false},()=>{
                    this.getPageData()
                })
            },
            errorCallBack: (e) => {
            },
        })
    }
    //点击删除弹窗
    delModal=()=>{
        return <Modal
            title={"提醒"}
            visible={this.state.delModalVisible}
            onCancel={()=>{this.setState({delModalVisible:false})}}
            onOk={()=>{this.setState({delModalVisible:false})}}
        >
            <div>你确定删除这条约稿吗？</div>
        </Modal>
    };
    //数据详情弹出框
    detailsModal=()=>{
        let column = [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                align: 'left',
                width:"200px"
            },
            {
                title: '部门',
                dataIndex: 'department',
                key: 'department',
                align: 'left',
                width:"200px"
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align: 'left',
                width:"200px"
            },
            {
                title: '写稿时间',
                dataIndex: 'time',
                key: 'time',
                align: 'left',
                width:"200px"
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'left',
                width:"200px",
                render:((text,record)=>{
                    return <Button type={"primary"}>查看稿件</Button>
                })
            },
        ];
        let dataSource = [
            {
                name:"zhangsan ",
                department:"宣传部",
                status:"已提交",
                time:"11631561"
            }
        ];
        return <Modal
            title={"查看约稿任务"}
            visible={this.state.datailsModalVisible}
            onCancel={()=>{this.setState({datailsModalVisible:false})}}
        >
            <div className={"approximationsManagement"}>
                <div style={{display:"flex"}}>
                    <Form.Item label={"要求回稿时间"} style={{display:"flex"}}>

                    </Form.Item>
                    <Form.Item label={"领取时间"} style={{display:"flex"}}>

                    </Form.Item>
                </div>
                <div style={{display:"flex"}}>
                    <Form.Item label={"状态"} style={{display:"flex"}}>

                    </Form.Item>
                    <Form.Item label={"创建时间"} style={{display:"flex"}}>

                    </Form.Item>
                </div>
                <div style={{display:"flex"}}>
                    <Form.Item label={"发布媒体"} style={{display:"flex"}}>

                    </Form.Item>
                    <Form.Item label={"发布人"} style={{display:"flex"}}>

                    </Form.Item>
                </div>
                <div style={{display:"flex"}}>
                    <Form.Item label={"稿件要求"} style={{display:"flex"}}>

                    </Form.Item>
                </div>
                <div style={{display:"flex"}}>
                    <Form.Item label={"约稿对象"} style={{display:"flex"}}>
                        <Scrollbars>
                            <BaseTable columns={column} dataSource={dataSource}/>
                        </Scrollbars>
                    </Form.Item>
                </div>
                <style>
                    {`.approximationsManagement .ant-form-item-label{
                            width: 100px;
                            vertical-align: top
                     }`}
                </style>
            </div>
        </Modal>
    };
    //获取当前页面的数据
    getPageData = ()=>{
        let {param} = this.state;
        this.request({
            url: "/cm-sites-business/bd/busAppointment/page",
            method:"post",
            contentType: "json",
            body: param,
            callBack: (res) => {
                this.setState({dataSource:res.data,total:res.count})
            },
            errorCallBack: (e) => {
            },
        })
    };
    //选中通讯员弹窗
    checkCorrespondent = ()=>{
        const columns = [ {
            title: '用户账号',
            dataIndex: 'userAccount',
            key: 'userAccount',
            align: 'left',
            ellipsis: true,
            render:(text,record)=>{
                return <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{text}</div>
            }
            }, {
                title: '用户姓名',
                dataIndex: 'userName',
                key: 'userName',
                align: 'left',
                width:"150px",
                render:(text,record)=>{
                    return <div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{text}</div>
                }
            }, {
                title: '部门',
                dataIndex: 'department',
                key: 'department',
                align: 'left',
                width:"150px",
                render:(text,record)=> {
                    return <div
                        style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{text}</div>
                }
            }];
        const dataSource = [
            {
                userAccount:"zhangsan",
                userName:"张三",
                department:"宣传部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            }, {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            },
            {
                userAccount:"lisi",
                userName:"李四",
                department:"测试部"
            }
        ]
        return <Modal
            title={"选择通讯员"}
            visible={this.state.checkCorrespondentVisible}
            onCancel={()=>{this.setState({checkCorrespondentVisible:false})}}
            width={600}
        >
            <div style={{display:"flex",justifyContent: "space-between",marginBottom:"24px"}}>
                <div></div>
                <Search
                    placeholder={"请输入搜索内容"}
                    allowClear={true}
                    onChange={(e)=>{

                    }}
                    onSearch={(value)=>{
                        console.log(1)}}
                    style={{width: 272,height:32}}
                />
            </div>
            <div>
                <div style={{margin:"0 32px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={250}>
                        <BaseTable columns={columns} dataSource={dataSource}/>
                    </Scrollbars>
                </div>
                {dataSource&&dataSource.length>0 ? this.renderCheckPage():""}
            </div>

        </Modal>
    }
    //选中通讯员分页
    renderCheckPage = ()=>{
        let {param,checkCorrespondentTotal}=this.state;
        return(
            <div style={{textAlign:"right",padding:"16px 32px",borderTop:"1px solid rgb(230, 230, 230)"}}>
                <Pagination
                    size="middle"
                    total={checkCorrespondentTotal}
                    showSizeChanger
                    showQuickJumper
                    current={param.num}
                    pageSize={param.size}
                    onChange={(e)=>{
                        param.num = e;
                        this.setState({});
                    }} //页码改变时回调
                    onShowSizeChange={(page,size)=>{
                        param.size = size;
                        this.setState({});
                    }} //每页条数改变回调
                />
            </div>
        )
    }
    //表单验证
    checkForm = ()=>{

    }
}

export default ApproximationsManagement;